import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamPermissionContainerComponent } from './team-permission-container.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TeamPermissionListingComponent } from './team-permission-listing/team-permission-listing.component';
import { TeamPermissionEditComponent } from './team-permission-edit/team-permission-edit.component';
import { TeamPermissionDetailsComponent } from './team-permission-edit/team-permission-details/team-permission-details.component';
import { TeamPermissionMembersComponent } from './team-permission-edit/team-permission-members/team-permission-members.component';
import { TeamMembersAddComponent } from './team-permission-edit/team-permission-members/team-members-add/team-members-add.component';
import { TeamMembersEditComponent } from './team-permission-edit/team-permission-members/team-members-edit/team-members-edit.component';
import { TeamPermissionRoleComponent } from './team-permission-edit/team-permission-role/team-permission-role.component';
import { TeamRoleEditComponent } from './team-permission-edit/team-permission-role/team-role-edit/team-role-edit.component';
import { EffectsModule } from '@ngrx/effects';
import { SharedUtilitiesModule } from '../../../../utilities/shared-utilities.module';

export const teamPermAgGridModule = AgGridModule.withComponents([]);

@NgModule({
  declarations: [
    TeamPermissionContainerComponent,
    TeamPermissionListingComponent,
    TeamPermissionEditComponent,
    TeamPermissionDetailsComponent,
    TeamPermissionMembersComponent,
    TeamMembersAddComponent,
    TeamMembersEditComponent,
    TeamPermissionRoleComponent,
    TeamRoleEditComponent
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    teamPermAgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule
  ]
})
export class TeamPermissionModule { }
